import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    paddingBottom: 24,
  },
  tabs: {
    '& :hover': {
      // color: colors.black1,
      opacity: 1,
    },
    '& .Mui-selected': {
      color: `${Colors.black} !important`,
      textTransform: 'none !important',
      fontWeight: '700 !important',
    },
    '& .Mui-focusVisible': {
      // backgroundColor: `${colors.black1} !important`,
    },
    '& .MuiTab-root': {
      textTransform: 'none !important',
      fontSize: 14,
      fontWeight: '400',
      paddingBottom: '2px !important',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: Colors.primary,
      height: 1,
    },
  },
};

export default styles;
